import React from "react";
import PropTypes from "prop-types";

// Material imports
import withStyles from "@mui/styles/withStyles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//limitless imports
import Divider from "@limitless/modern/data-display/divider/Divider";
import Grid from "@limitless/modern/layout/Grid";
const SimpleAccordion = props => {
  const {
    classes,
    title,
    children,
    expanded,
    rootStyle,
    handleAccordionClick,
    totalCount,
    variant,
    descColor,
    showDivider
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    expanded: expanded,
    onChange: handleAccordionClick,
    className: classes.accordionStyling
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    className: classes.summaryRoot,
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      className: classes.icon
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    className: totalCount !== "" ? classes.titleWrapper : "",
    variant: variant
  }, title), totalCount !== "" && /*#__PURE__*/React.createElement(Typography, {
    className: totalCount !== "" ? classes.descWrapper : "",
    variant: variant,
    color: descColor
  }, totalCount)), /*#__PURE__*/React.createElement(AccordionDetails, {
    classes: {
      root: rootStyle
    }
  }, children)), showDivider && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      padding: "0px 0px 6px"
    },
    component: Divider
  }));
};
const styles = theme => ({
  icon: {
    color: theme.palette.secondary.main,
    fontSize: 40
  },
  titleWrapper: {
    width: 400
  },
  descWrapper: {
    paddingLeft: 16,
    width: "100%"
  }
});
export default withStyles(styles)(SimpleAccordion);
SimpleAccordion.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  expanded: PropTypes.bool,
  showDivider: PropTypes.bool,
  rootStyle: PropTypes.string,
  handleAccordionClick: PropTypes.func,
  totalCount: PropTypes.string,
  descColor: PropTypes.string,
  variant: PropTypes.string
};
SimpleAccordion.defaultProps = {
  totalCount: "",
  variant: "subtitle1",
  descColor: "textSecondary",
  showDivider: false
};